import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_HOSPITAL_DETAIL_QUERY_KEY, HOSPITAL } from "../types/CommonTypes";

async function getHospitalDetail(id?: string | null): Promise<HOSPITAL> {
  const { data } = await fetcher({
    url: `/hospital/${id}`,
  });
  return data;
}

function useGetHospitalDetailQuery(id?: string | null) {
  return useQuery({
    queryKey: [GET_HOSPITAL_DETAIL_QUERY_KEY, id],
    queryFn: () => getHospitalDetail(id),
    enabled: !!id,
  });
}

export default useGetHospitalDetailQuery;
